import React from "react";
import { TextField, InputAdornment, useTheme } from "@mui/material";
import { Search } from "@mui/icons-material";

type Props = {
  search: string;
  onSearchChange: (value: string) => void;
  disabled?: boolean;
};

const VaultSearch: React.FC<Props> = ({ search, onSearchChange, disabled }) => {
  const theme = useTheme();

  return (
    <TextField
      size="small"
      disabled={disabled}
      placeholder="Search secrets..."
      value={search}
      onChange={(e) => onSearchChange(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search sx={{ color: theme.palette.text.secondary, fontSize: 15 }} />
          </InputAdornment>
        ),
      }}
      sx={{
        mt: 1,
        width: "100%",
        "& .MuiOutlinedInput-root": {
          borderRadius: 2,
          bgcolor: "var(--fx-surface-base, #FFFFFF)",
          height: 30,
          "& input": {
            fontSize: 14,
            "&::placeholder": { fontSize: 14, color: theme.palette.text.secondary },
          },
          "& fieldset": { borderColor: theme.palette.divider },
          "&:hover fieldset": { borderColor: theme.palette.divider },
          "&.Mui-focused fieldset": { borderColor: theme.palette.primary.main, borderWidth: 1 },
        },
      }}
    />
  );
};

export default VaultSearch;
